export default __webpack_public_path__ + "static/media/dash2.1103afca.svg";